import { render, staticRenderFns } from "./CommissionOnShipping.vue?vue&type=template&id=7959285c&"
import script from "./CommissionOnShipping.vue?vue&type=script&lang=ts&"
export * from "./CommissionOnShipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports